export default "__VITE_ASSET__B$Q32V8c__"